import React, { useState } from "react";
import SalesGraphCore from "../../../../components/charts/SalesGraphCore";

export default function ProductSalesGraph({
  salesData,
  isLoading,
  interval = "daily",
  height = 280,
  debug = false,
}) {
  const [mode, setMode] = useState("amount"); // amount | quantity | growth

  return (
    <div className="h-full flex flex-col">
      <div className="flex gap-2 mb-3">
        <button
          type="button"
          onClick={() => setMode("amount")}
          className={`px-3 py-1 rounded-md text-sm border ${
            mode === "amount"
              ? "bg-yellow-300 text-black"
              : "border-border/60 text-foreground"
          }`}
        >
          Amount
        </button>
        <button
          type="button"
          onClick={() => setMode("quantity")}
          className={`px-3 py-1 rounded-md text-sm border ${
            mode === "quantity"
              ? "bg-yellow-300 text-black"
              : "border-border/60 text-foreground"
          }`}
        >
          Quantity
        </button>
        <button
          type="button"
          onClick={() => setMode("growth")}
          className={`px-3 py-1 rounded-md text-sm border ${
            mode === "growth"
              ? "bg-yellow-300 text-black"
              : "border-border/60 text-foreground"
          }`}
        >
          Growth
        </button>
      </div>

      <div className="flex-1 min-h-0">
        <SalesGraphCore
          salesData={salesData}
          isLoading={isLoading}
          interval={interval}
          mode={mode}
          height={height}
          debug={debug}
        />
      </div>
    </div>
  );
}